import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    TextField,
    Tooltip,
    CircularProgress, FormControlLabel, Checkbox
} from '@mui/material';
import HeaderAvatar from "./HeaderAvatar";
import {
    addVisit,
    addSlideToVisit,
    createVideoFolder,
    getVisits,
    getSlides,
    processProject,
    editVisitName,
    reorderVisitSlides,
    updateSlide, fetchProjects, deleteVisit, getSegmentVisits
} from '../services/api';
import Icon from "./Icon";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragEndEvent } from '@dnd-kit/core';
import VisitBox from '../components/VisitBox';
import { deleteVisitSlide } from '../services/api';
import {DragOverlay } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import {
    Add
} from '@mui/icons-material';
import {Link, LinkEdit, Slide} from '../services/types'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SlideEditModal from '../components/SlideEditModal'
import { SelectChangeEvent } from '@mui/material/Select';
import LinkEditModal from "./LinkEditModal";

interface Scenario {
    id: string;
    name: string;
}
interface VisitSlide {
    id: string;
    slide: Slide;
}
interface Visit {
    id: string;
    name: string;
    is_default: boolean;
    mcd_nonprescriber: string;
    mcd_trialist: string;
    mcd_user: string;
    mcd_advocate: string;
    endo_nonprescriber: string;
    endo_trialist: string;
    endo_user: string;
    endo_advocate: string;
    obstetrics_nonprescriber: string;
    obstetrics_trialist: string;
    obstetrics_user: string;
    obstetrics_advocate: string;
    peri_nonprescriber: string;
    peri_trialist: string;
    peri_user: string;
    peri_advocate: string;
    post_nonprescriber: string;
    post_trialist: string;
    post_prescriber: string;
    post_advocate: string;
    project_id: string;
    sort: number;
    external_id?: string;
    slides: VisitSlide[];
    scenarios: Scenario;
}

interface ScenarioEditorProps {
    scenario: Scenario;
}
interface Presentation {
    id: string;
    name: string;
    photo_url: string;
    clm_type_id: string;
    // Add other properties as needed
}

// interface VisitBoxProps {
//     visit: Visit;
//     onAddSlide: (visitId: string) => void;
// }
// interface SortableSlideItemProps {
//     slide: VisitSlide;
// }
const ScenarioEditor: React.FC<ScenarioEditorProps> = ({ scenario }) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const [slides, setSlides] = useState<Slide[]>([]);
    const [visits, setVisits] = useState<Visit[]>([]);
    const [segmentVisits, setSegmentVisits] = useState<Visit[]>([]);
    const [selectAddVisit, setSelectAddVisit] = useState<string>('');
    const [selectEditNameVisit, setSelectEditNameVisit] = useState<string>('');
    const [selectEditIsDefaultVisit, setSelectEditIsDefaultVisit] = useState<boolean>(true);
    const [selectEditMCDNonprescriberVisit, setSelectEditMCDNonprescriberVisit] = useState<string>('');
    const [selectEditMCDTrialistVisit, setSelectEditMCDTrialistVisit] = useState<string>('');
    const [selectEditMCDUserVisit, setSelectEditMCDUserVisit] = useState<string>('');
    const [selectEditMCDAdvocateVisit, setSelectEditMCDAdvocateVisit] = useState<string>('');
    const [selectEditEndoNonprescriberVisit, setSelectEditEndoNonprescriberVisit] = useState<string>('');
    const [selectEditEndoTrialistVisit, setSelectEditEndoTrialistVisit] = useState<string>('');
    const [selectEditEndoUserVisit, setSelectEditEndoUserVisit] = useState<string>('');
    const [selectEditEndoAdvocateVisit, setSelectEditEndoAdvocateVisit] = useState<string>('');
    const [selectEditObstetricsNonprescriberVisit, setSelectEditObstetricsNonprescriberVisit] = useState<string>('');
    const [selectEditObstetricsTrialistVisit, setSelectEditObstetricsTrialistVisit] = useState<string>('');
    const [selectEditObstetricsUserVisit, setSelectEditObstetricsUserVisit] = useState<string>('');
    const [selectEditObstetricsAdvocateVisit, setSelectEditObstetricsAdvocateVisit] = useState<string>('');
    const [selectEditPeriNonprescriberVisit, setSelectEditPeriNonprescriberVisit] = useState<string>('');
    const [selectEditPeriTrialistVisit, setSelectEditPeriTrialistVisit] = useState<string>('');
    const [selectEditPeriUserVisit, setSelectEditPeriUserVisit] = useState<string>('');
    const [selectEditPeriAdvocateVisit, setSelectEditPeriAdvocateVisit] = useState<string>('');
    const [selectEditPostNonprescriberVisit, setSelectEditPostNonprescriberVisit] = useState<string>('');
    const [selectEditPostTrialistVisit, setSelectEditPostTrialistVisit] = useState<string>('');
    const [selectEditPostPrescriberVisit, setSelectEditPostPrescriberVisit] = useState<string>('');
    const [selectEditPostAdvocateVisit, setSelectEditPostAdvocateVisit] = useState<string>('');
    const [isProcessModalOpen, setProcessModalOpen] = useState(false);
    const [isVisitCreateModalOpen, setIsVisitCreateModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [createVisitName, setCreateVisitName] = useState('');
    const [currentVisitName, setCurrentVisitName] = useState('');
    const [isSlideSelectionModalOpen, setIsSlideSelectionModalOpen] = useState(false);
    const [onSlideSelect, setOnSlideSelect] = useState<(slideId: string) => void>(() => {});
    const [isSlideEditModalOpen, setIsSlideEditModalOpen] = useState(false);
    const [selectedSlide, setSelectedSlide] = useState<Slide | null>(null);
    const [projectSlides, setProjectSlides] = useState<Slide[]>([]);
    const [projectHotSlides, setProjectHotSlides] = useState<Slide[]>([]);
    const [presentations, setPresentations] = useState<Presentation[]>([]);
    const [selectedProject, setSelectedProject] = useState<string>('');


    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const fetchSlides = async () => {
        try {
            const response = await getSlides(scenario.id);
            setSlides(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
        }
    };
    const fetchVisits = async () => {
        try {
            const response = await getVisits(scenario.id, 1, 50);
            setVisits(response.items);
        } catch (error) {
            console.error('Error fetching slides:', error);
            // setVisits([]);
        }
    };
    const fetchSegmentVisits = async () => {
        try {
            const response = await getSegmentVisits();
            setSegmentVisits(response);
            console.log(response)
        } catch (error) {
            console.error('Error fetching slides:', error);
            // setVisits([]);
        }
    };
    useEffect(() => {
        fetchSlides();
        fetchVisits();
        loadPresentations();
        fetchSegmentVisits();
    }, [scenario.id]);

    const handleCreateVisit = async () => {

        try {
            const cvisit = {
                name: createVisitName,
                scenario_id: scenario.id,
                sort: 1,
                external_id: ''
            }
            await addVisit(cvisit);
            fetchSlides();
            fetchVisits()
            setIsVisitCreateModalOpen(false)
        } catch (error) {
            console.error('Error creating folder:', error);
        }

    };


    const fetchProjectSlides = async (projectId: string) => {
        try {
            const response = await getSlides(projectId);
            setProjectSlides(response.items);
        } catch (error) {
            console.error('Ошибка при получении слайдов проекта:', error);
        }
    };
    const loadPresentations = async () => {
        const data = await fetchProjects(1, 100);
        setPresentations(data.items);
    };
    const handleProjectChange = (event: SelectChangeEvent<string>) => {
        const projectId = event.target.value;
        setSelectedProject(projectId);
        fetchProjectSlides(projectId);
    };
    const handleMCDNonprescriberChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditMCDNonprescriberVisit(visitId)
    };
    const handleMCDTrialistChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditMCDTrialistVisit(visitId)
    };
    const handleMCDUserChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditMCDUserVisit(visitId)
    };
    const handleMCDAdvocateChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditMCDAdvocateVisit(visitId)
    };
    const handleEndoNonprescriberChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditEndoNonprescriberVisit(visitId)
    };
    const handleEndoTrialistChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditEndoTrialistVisit(visitId)
    };
    const handleEndoUserChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditEndoUserVisit(visitId)
    };
    const handleEndoAdvocateChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditEndoAdvocateVisit(visitId)
    };
    const handleObstetricsNonprescriberChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditObstetricsNonprescriberVisit(visitId)
    };
    const handleObstetricsTrialistChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditObstetricsTrialistVisit(visitId)
    };
    const handleObstetricsUserChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditObstetricsUserVisit(visitId)
    };
    const handleObstetricsAdvocateChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditObstetricsAdvocateVisit(visitId)
    };
    const handlePeriNonprescriberChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPeriNonprescriberVisit(visitId)
    };
    const handlePeriTrialistChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPeriTrialistVisit(visitId)
    };
    const handlePeriUserChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPeriUserVisit(visitId)
    };
    const handlePeriAdvocateChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPeriAdvocateVisit(visitId)
    };
    const handlePostNonprescriberChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPostNonprescriberVisit(visitId)
    };
    const handlePostTrialistChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPostTrialistVisit(visitId)
    };
    const handlePostPrescriberChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPostPrescriberVisit(visitId)
    };
    const handlePostAdvocateChange = (event: SelectChangeEvent<string>) => {
        const visitId = event.target.value;
        setSelectEditPostAdvocateVisit(visitId)
    };
    const handleIsDefaultChange = () => {
        setSelectEditIsDefaultVisit(!selectEditIsDefaultVisit)
    };


    const handleReorderSlides = async (visitId: string, newOrder: string[]) => {
        try {
            await reorderVisitSlides(visitId, newOrder);
            // Update the local state to reflect the new order
            setVisits(prevVisits => prevVisits.map(visit =>
                visit.id === visitId
                    ? {
                        ...visit,
                        slides: newOrder.map(id => visit.slides.find(slide => slide.id === id))
                            .filter((slide): slide is VisitSlide => slide !== undefined)
                    }
                    : visit
            ));
        } catch (error) {
            console.error('Error reordering slides:', error);
        }
    };


    const handleAddSlideModal = async (visitId:string) => {
        setIsSlideSelectionModalOpen(true);
        setSelectAddVisit(visitId)
    };


    const handleDeleteSlide = async (visitSlideId: string) => {
        try {
            await deleteVisitSlide(visitSlideId);
            fetchVisits()
        } catch (error) {
            console.error('Error deleting slide:', error);
            // Handle error (e.g., show an error message to the user)
        }
    };

    const handleAddSlideToVisit = async (slideId: string) => {
        setIsSlideSelectionModalOpen(false);
        try {
            await addSlideToVisit(selectAddVisit, slideId);
            const updatedVisits = await getVisits(scenario.id, 1, 50);
            fetchVisits()
        } catch (error) {
            console.error('Error adding slide to visit:', error);
        }
    };
    const handleUpdateSlide = async (updatedSlide: Slide) => {
        try {
            await updateSlide(updatedSlide.id, {
                description: updatedSlide.description,
                duration: updatedSlide.duration,
                external_id: updatedSlide.external_id,
            });
            fetchSlides();
        } catch (error) {
            console.error('Error updating slide:', error);
        }
    };
    const handleDeleteVisit = async (visitId:string) => {
        await  deleteVisit(visitId)
        fetchVisits()
    };
    const handleEditNameModal = async (
        visitId:string,
        visitName: string,
        visitIsDefault: boolean,
        visitMCDNonprescriber:string,
        visitMCDTrialist:string,
        visitMCDUser:string,
        visitMCDAdvocate:string,
        visitEndoNonprescriber:string,
        visitEndoTrialist:string,
        visitEndoUser:string,
        visitEndoAdvocate:string,
        visitObstetricsNonprescriber:string,
        visitObstetricsTrialist:string,
        visitObstetricsUser:string,
        visitObstetricsAdvocate:string,
        visitPeriNonprescriber:string,
        visitPeriTrialist:string,
        visitPeriUser:string,
        visitPeriAdvocate:string,
        visitPostNonprescriber:string,
        visitPostTrialist:string,
        visitPostPrescriber:string,
        visitPostAdvocate:string
    ) => {
        setIsEditModalOpen(true);
        setCurrentVisitName(visitName)
        setSelectEditIsDefaultVisit(visitIsDefault)
        setSelectEditNameVisit(visitId)
        setSelectEditMCDNonprescriberVisit(visitMCDNonprescriber)
        setSelectEditMCDTrialistVisit(visitMCDTrialist)
        setSelectEditMCDUserVisit(visitMCDUser)
        setSelectEditMCDAdvocateVisit(visitMCDAdvocate)
        setSelectEditEndoNonprescriberVisit(visitEndoNonprescriber)
        setSelectEditEndoTrialistVisit(visitEndoTrialist)
        setSelectEditEndoUserVisit(visitEndoUser)
        setSelectEditEndoAdvocateVisit(visitEndoAdvocate)
        setSelectEditObstetricsNonprescriberVisit(visitObstetricsNonprescriber)
        setSelectEditObstetricsTrialistVisit(visitObstetricsTrialist)
        setSelectEditObstetricsUserVisit(visitObstetricsUser)
        setSelectEditObstetricsAdvocateVisit(visitObstetricsAdvocate)
        setSelectEditPeriNonprescriberVisit(visitPeriNonprescriber)
        setSelectEditPeriTrialistVisit(visitPeriTrialist)
        setSelectEditPeriUserVisit(visitPeriUser)
        setSelectEditPeriAdvocateVisit(visitPeriAdvocate)
        setSelectEditPostNonprescriberVisit(visitPostNonprescriber)
        setSelectEditPostTrialistVisit(visitPostTrialist)
        setSelectEditPostPrescriberVisit(visitPostPrescriber)
        setSelectEditPostAdvocateVisit(visitPostAdvocate)

    };
    const handleEditVisitName = async () => {
        setIsEditModalOpen(false);
        await editVisitName(selectEditNameVisit, currentVisitName, selectEditIsDefaultVisit, selectEditMCDNonprescriberVisit, selectEditMCDTrialistVisit, selectEditMCDUserVisit, selectEditMCDAdvocateVisit, selectEditEndoNonprescriberVisit, selectEditEndoTrialistVisit, selectEditEndoUserVisit, selectEditEndoAdvocateVisit, selectEditObstetricsNonprescriberVisit, selectEditObstetricsTrialistVisit, selectEditObstetricsUserVisit, selectEditObstetricsAdvocateVisit, selectEditPeriNonprescriberVisit, selectEditPeriTrialistVisit, selectEditPeriUserVisit, selectEditPeriAdvocateVisit, selectEditPostNonprescriberVisit, selectEditPostTrialistVisit, selectEditPostPrescriberVisit, selectEditPostAdvocateVisit);
        fetchVisits()
    };

    // const handleSlideClick = (slide: Slide) => {
    //     setSelectedSlide(slide as Slide);
    //     setIsSlideEditModalOpen(true);
    // };
    //
    // const handleGenerateClick = async () => {
    //     setProcessModalOpen(true)
    //     await processProject(scenario.id)
    //     setProcessModalOpen(false)
    // };
    // const handleOpenLink = () => {
    //     window.open('https://app.productscript.ru/'+scenario.id+'/', '_blank');
    // };
    //
    // const handleDownloadLink = () => {
    //     window.open('https://static.productscript.ru/uploads/archives/'+scenario.id+'/source.zip', '_blank');
    // };

    return (
        <Box display="flex" sx={{height: 'calc(100vh - 64px)'}}>
            <Box sx={{width: '100%', height: 'calc(100% - 64px)', position: 'absolute', right: 0, overflowX: 'hidden', overflowY: 'scroll'}}>
                <Box sx={{width: 'calc(100% - 24px)'}} p={2}>
                    {Array.isArray(visits) && visits.map((visit) => (
                        // <VisitBox key={visit.id} visit={visit} onAddSlide={()=>handleAddSlideModal(visit.id)} />
                        <VisitBox
                            key={visit.id}
                            visit={visit}
                            onAddSlide={handleAddSlideModal}
                            onEditName={handleEditNameModal}
                            onDeleteVisit={handleDeleteVisit}
                            onReorderSlides={handleReorderSlides}
                            onDeleteSlide={handleDeleteSlide}
                        />
                    ))}
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <Button sx={{color: '#3a485b', display: 'flex', gap: '4px'}}
                                onClick={() => setIsVisitCreateModalOpen(true)}><Add/> Добавить визит</Button>
                    </Box>
                </Box>
            </Box>


            {/* Модальное окно создания главы */}
            <Modal open={isVisitCreateModalOpen} onClose={() => setIsVisitCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300 }}>
                        <Typography variant="h6">Добавить визит</Typography>
                        <TextField
                            label="Название"
                            value={createVisitName}
                            onChange={(e) => setCreateVisitName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreateVisit}>
                                Добавить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsVisitCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно создания главы */}
            <Modal open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
                <Box sx={{flexGrow:1, maxHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'flex-start', overflowY: 'scroll'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, width: 800, minWidth: 300 }}>
                        <Typography variant="h6">Редактировать название</Typography>
                        <TextField
                            label="Название"
                            value={currentVisitName}
                            onChange={(e) => setCurrentVisitName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                            sx={{ mb: 2 }}
                        />
                        <FormControlLabel sx={{ mb: 2, ml: 1 }} control={<Checkbox checked={selectEditIsDefaultVisit} onChange={handleIsDefaultChange} />} label="Не является Multidirection визитом"/>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label1">MCD Non-Prescriber</InputLabel>
                            <Select labelId="project-select-label1" id="project-select1" value={selectEditMCDNonprescriberVisit} label="Выберите визит" onChange={handleMCDNonprescriberChange}>
                                <MenuItem key="emptyVisit1" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label2">MCD Trialist</InputLabel>
                            <Select labelId="project-select-label2" id="project-select2" value={selectEditMCDTrialistVisit} label="Выберите визит" onChange={handleMCDTrialistChange}>
                                <MenuItem key="emptyVisit1" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label3">MCD User</InputLabel>
                            <Select labelId="project-select-label3" id="project-select3" value={selectEditMCDUserVisit} label="Выберите визит" onChange={handleMCDUserChange}>
                                <MenuItem key="emptyVisit1" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label4">MCD Advocate</InputLabel>
                            <Select labelId="project-select-label4" id="project-select4" value={selectEditMCDAdvocateVisit} label="Выберите визит" onChange={handleMCDAdvocateChange}>
                                <MenuItem key="emptyVisit1" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label5">Endo Non-Prescriber</InputLabel>
                            <Select labelId="project-select-label5" id="project-select5" value={selectEditEndoNonprescriberVisit} label="Выберите визит" onChange={handleEndoNonprescriberChange}>
                                <MenuItem key="emptyVisit5" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label6">Endo Trialist</InputLabel>
                            <Select labelId="project-select-label6" id="project-select6" value={selectEditEndoTrialistVisit} label="Выберите визит" onChange={handleEndoTrialistChange}>
                                <MenuItem key="emptyVisit6" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label7">Endo User</InputLabel>
                            <Select labelId="project-select-label7" id="project-select7" value={selectEditEndoUserVisit} label="Выберите визит" onChange={handleEndoUserChange}>
                                <MenuItem key="emptyVisit7" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label8">Endo Advocate</InputLabel>
                            <Select labelId="project-select-label8" id="project-select8" value={selectEditEndoAdvocateVisit} label="Выберите визит" onChange={handleEndoAdvocateChange}>
                                <MenuItem key="emptyVisit8" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label9">Obstetrics Non-Prescriber</InputLabel>
                            <Select labelId="project-select-label9" id="project-select9" value={selectEditObstetricsNonprescriberVisit} label="Выберите визит" onChange={handleObstetricsNonprescriberChange}>
                                <MenuItem key="emptyVisit9" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label10">Obstetrics Trialist</InputLabel>
                            <Select labelId="project-select-label10" id="project-select10" value={selectEditObstetricsTrialistVisit} label="Выберите визит" onChange={handleObstetricsTrialistChange}>
                                <MenuItem key="emptyVisit10" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label11">Obstetrics User</InputLabel>
                            <Select labelId="project-select-label11" id="project-select11" value={selectEditObstetricsUserVisit} label="Выберите визит" onChange={handleObstetricsUserChange}>
                                <MenuItem key="emptyVisit11" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label12">Obstetrics Advocate</InputLabel>
                            <Select labelId="project-select-label12" id="project-select12" value={selectEditObstetricsAdvocateVisit} label="Выберите визит" onChange={handleObstetricsAdvocateChange}>
                                <MenuItem key="emptyVisit12" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label13">Peri Non-Prescriber</InputLabel>
                            <Select labelId="project-select-label13" id="project-select13" value={selectEditPeriNonprescriberVisit} label="Выберите визит" onChange={handlePeriNonprescriberChange}>
                                <MenuItem key="emptyVisit13" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label14">Peri Trialist</InputLabel>
                            <Select labelId="project-select-label14" id="project-select14" value={selectEditPeriTrialistVisit} label="Выберите визит" onChange={handlePeriTrialistChange}>
                                <MenuItem key="emptyVisit14" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label15">Peri User</InputLabel>
                            <Select labelId="project-select-label15" id="project-select15" value={selectEditPeriUserVisit} label="Выберите визит" onChange={handlePeriUserChange}>
                                <MenuItem key="emptyVisit15" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label16">Peri Advocate</InputLabel>
                            <Select labelId="project-select-label16" id="project-select16" value={selectEditPeriAdvocateVisit} label="Выберите визит" onChange={handlePeriAdvocateChange}>
                                <MenuItem key="emptyVisit16" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label17">Post Non-Prescriber</InputLabel>
                            <Select labelId="project-select-label17" id="project-select17" value={selectEditPostNonprescriberVisit} label="Выберите визит" onChange={handlePostNonprescriberChange}>
                                <MenuItem key="emptyVisit17" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label18">Post Trialist</InputLabel>
                            <Select labelId="project-select-label18" id="project-select18" value={selectEditPostTrialistVisit} label="Выберите визит" onChange={handlePostTrialistChange}>
                                <MenuItem key="emptyVisit18" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label19">Post Prescriber</InputLabel>
                            <Select labelId="project-select-label19" id="project-select19" value={selectEditPostPrescriberVisit} label="Выберите визит" onChange={handlePostPrescriberChange}>
                                <MenuItem key="emptyVisit19" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label20">Post Advocate</InputLabel>
                            <Select labelId="project-select-label20" id="project-select20" value={selectEditPostAdvocateVisit} label="Выберите визит" onChange={handlePostAdvocateChange}>
                                <MenuItem key="emptyVisit20" value="">{"Не выбрано"}</MenuItem>
                                {segmentVisits.map((visit) => (
                                    visit.name ? (
                                        <MenuItem key={visit.id} value={visit.id}>{visit.scenarios.name} {'->'} {visit.name}</MenuItem>
                                    ) : null
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleEditVisitName}>
                                Сохранить
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsEditModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно выбора слайда */}

            <Modal open={isSlideSelectionModalOpen} onClose={() => setIsSlideSelectionModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center', overflowY: 'scroll'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600, minWidth: 300, maxHeight:'90vh', overflow: 'scroll' }}>
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="project-select-label">Выберите проект</InputLabel>
                            <Select
                                labelId="project-select-label"
                                id="project-select"
                                value={selectedProject}
                                label="Выберите проект"
                                onChange={handleProjectChange}
                            >
                                {presentations.map((presentation) => (
                                    <MenuItem key={presentation.id} value={presentation.id}>
                                        {presentation.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box className='addModalSlideItems'>
                            {(selectedProject ? projectSlides : slides).map((slide) => (
                                <Box className='addModalSlideItem' key={slide.id} onClick={() => handleAddSlideToVisit(slide.id)}>
                                    <img src={slide.preview} alt={slide.name}/>
                                </Box>
                            ))}
                        </Box>

                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={() => setIsSlideSelectionModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>


            <Modal open={isProcessModalOpen}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography sx={{mb: 3}}>Идет обработка</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                <CircularProgress style={{color: '#3a485b'}}/>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>


        </Box>
    );
};
export default ScenarioEditor;
